import { Const } from '../lib/const.cls'

export const getters = {
	[Const.BREAKFAST_OPTIONS]: (state) => { return state.breakfastOptions },
	[Const.WEIGHT_OPTIONS]: (state) => { return state.weightOptions },
	[Const.MOOD_OPTIONS]: (state) => { return state.moodOptions },
	
	[Const.BOWEL_MOVEMENTS_OPTIONS]: (state) => { return state.bowelMovementsOptions },
	[Const.POOP_COLOR_OPTIONS]: (state) => { return state.poopColorOptions },
	[Const.POOP_EXPERIENCE_OPTIONS]: (state) => { return state.poopExperienceOptions },
	[Const.TIME_DURATION_OPTIONS]: (state) => { return state.timeDurationOptions },
	[Const.PUSH_PRESSURE_OPTIONS]: (state) => { return state.pushPressureOptions },
	[Const.POOP_COMPLICATIONS_OPTIONS]: (state) => { return state.poopComplicationsOptions },
	
	[Const.GET_REGISTER_DISEASE_LIST]: (state) => { return state.diseaseList },

	//========prescription
	[Const.GET_PATIENT_PRESCRIPTION_LIST]: (state) => { return state.prescriptionList },
	[Const.GET_PATIENT_PRESCRIPTION_DETAIL]: (state) => { return state.prescriptionView },
	//========test-report
	[Const.GET_PATIENT_TEST_REPORT_LIST]: (state) => { return state.testReportList },
	[Const.GET_PATIENT_TEST_REPORT_DETAIL]: (state) => { return state.testReportDetail },
	//========appointment
	[Const.GET_APPOINTMENT_LIST]: (state) => { return state.appointmentList },
	[Const.GET_APPOINTMENT_DETAIL]: (state) => { return state.appointmentDetail },
	[Const.GET_APPOINTMENT_INFO]: (state) => { return state.appointmentInfo },
	[Const.GET_AVAILABLE_SLOTS_LIST]: (state) => { return state.totalSlotList },
	[Const.GET_BUSY_SLOT_LIST]: (state) => { return state.busySlotList },
	[Const.GET_PATIENT_BUSY_SLOT]: (state) => { return state.patientBusySlot },
	//==============obt call
	[Const.GET_CHECK_OBT_CALL]: (state) => { return state.checkObtCall },
	//========notification
	[Const.GET_NOTIFICATION_LIST]: (state) => { return state.notificationList },
	[Const.GET_INITIAL_DATA]: (state) => { return state.initialData },
	[Const.GET_CHART_DATA]: (state) => { return state.chartData },
	[Const.GET_MEDICINE_LIST]: (state) => { return state.medicineList },
	[Const.GET_TASK_ACTION_LIST]: (state) => { return state.taskActionList },
}



// WEBPACK FOOTER //
// ./src/plugins/Gini/provider/candle-history/store-addons/getters.js